<script lang="ts">
	import Whatsapp from "@svg/Whatsapp.svelte";
	import Link from "@svg/Link.svelte";
	import { copyToClipboard } from "@utils/copyToClipboard.ts";
	import { algoliaFireJobOfferSharedEvent } from "@stores/algolia";

	export let link: string = "";
	export let objectID: string = "";
	export let index: number = -1;
</script>

<div class="mx-auto flex flex-col p-2 md:my-4 md:w-1/2">
	<h3 class="text-2xl">Fanpage delen</h3>
	<ul class="space-y-4 px-2 py-4">
		<li>
			<!-- Desktop WhatsApp share link -->
			<a
				class="hidden items-center gap-4 lg:flex"
				href="https://web.whatsapp.com/send?text=Check deze job! Iets voor jou? 👀🌰%0A{link}?utm_source=whatsapp%26utm_medium=social-share"
				target="_blank"
				on:click={() => {
					algoliaFireJobOfferSharedEvent({
						objectID: objectID,
						afterSearch: {
							positions: index
						}
					});
				}}
			>
				<Whatsapp class="h-7 w-8" />
				Delen op whatsapp
			</a>
			<!-- Mobile / iPad WhatsApp share link -->
			<a
				class="flex items-center gap-4 lg:hidden"
				href="whatsapp://send?text=Check deze job! Iets voor jou? 👀🌰%0A{link}?utm_source=whatsapp%26utm_medium=social-share"
				data-action="share/whatsapp/share"
				on:click={() => {
					algoliaFireJobOfferSharedEvent({
						objectID: objectID,
						afterSearch: {
							positions: index
						}
					});
				}}
			>
				<Whatsapp class="h-8 w-8" />
				Delen op whatsapp
			</a>
		</li>

		<!-- Copy link functionality -->
		<li>
			<button
				type="button"
				on:click={() => {
					copyToClipboard(link, "Fanpage link gekopieerd");
					algoliaFireJobOfferSharedEvent({
						objectID: objectID,
						afterSearch: {
							positions: index
						}
					});
				}}
				class="flex items-center gap-4"
			>
				<Link class="h-8 w-8 -rotate-45 fill-black" />
				Kopieer link
			</button>
		</li>
	</ul>
</div>
